import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

const ForeignActivitiesIntro = function () {
  return (
    <div>
      <h1 className="section-header">{i18n.t('foreign.pvq.activities.intro.intro0')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('foreign.pvq.activities.intro.intro1')}
        {i18n.m('foreign.pvq.activities.intro.intro2')}
        <ul>
          <li>{i18n.m('foreign.pvq.activities.intro.intro3')}</li>
          <li>{i18n.m('foreign.pvq.activities.intro.intro4')}</li>
          <li>{i18n.m('foreign.pvq.activities.intro.intro5')}</li>
          <li>{i18n.m('foreign.pvq.activities.intro.intro6')}</li>
        </ul>
      </Field>
    </div>
  );
};

export default ForeignActivitiesIntro;
